import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PartnerOrgFilterStateService {

  active: boolean = true;
  pendingActive: boolean = true;
  onboardingInProgress: boolean = true;
  pendingInactive: boolean = true;
  inactive: boolean = true;
  terminated: boolean = true;
  deleted: boolean = true;
  staging: boolean = true;


  reset(): void {
    this.resetStatusFilters();
  }

  resetStatusFilters(): void {
    this.active = true;
    this.pendingActive = true;
    this.onboardingInProgress = true;
    this.pendingInactive = true;
    this.inactive = true;
    this.terminated = true;
    this.deleted = true;
    this.staging = true;
  }

  allStatusFiltersEnabled(): boolean {
    return this.active
      && this.pendingActive
      && this.onboardingInProgress
      && this.pendingInactive
      && this.inactive
      && this.terminated
      && this.deleted
      && this.staging;
  }

  isStatusFilterActive(): boolean {
    return !this.active
      || !this.pendingActive
      || !this.onboardingInProgress
      || !this.pendingInactive
      || !this.inactive
      || !this.terminated
      || !this.deleted
      || !this.staging;
  }

  allStatusFiltersDisabled(): boolean {
    return !this.active
      && !this.pendingActive
      && !this.onboardingInProgress
      && !this.pendingInactive
      && !this.inactive
      && !this.terminated
      && !this.deleted
      && !this.staging
  }

  isActiveFilterActive(): boolean {
    return this.active;
  }

  isPendingActiveFilterActive(): boolean {
    return this.pendingActive;
  }

  isOnboardingInProgressFilterActive(): boolean {
    return this.onboardingInProgress;
  }

  isPendingInactiveFilterActive(): boolean {
    return this.pendingInactive;
  }

  isInactiveFilterActive(): boolean {
    return this.inactive;
  }

  isTerminatedFilterActive(): boolean {
    return this.terminated;
  }

  isDeletedFilterActive(): boolean {
    return this.deleted;
  }

  isStagingFilterActive(): boolean {
    return this.staging;
  }

}
